export class OrderDto {

  public readonly id!: string;
  public readonly transactionId: string | undefined;
  public readonly netAmount!: number;
  public readonly grossAmount!: number;
  public readonly currencyCode!: string;

  constructor(init?: Partial<OrderDto> | undefined) {
    Object.assign(this, init);
  }
}
